export const toCamelCase = (string: string | undefined) => {
  if (!string) {
    return '';
  }
  return string
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
};
